var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon } from '@a-type/ui';
import * as CONFIG from '../config.js';
import { useWasLoggedIn } from '../hooks/useWasLoggedIn.js';
import { useIsLoggedIn } from '../react.js';
export function LogoutButton(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const isLoggedIn = useIsLoggedIn();
    if (!isLoggedIn) {
        return null;
    }
    return (_jsx(Button, Object.assign({}, props, { render: _jsx(LogoutLink, { returnTo: props.returnTo }), children: children !== null && children !== void 0 ? children : (_jsxs(_Fragment, { children: ["Log out", _jsx(Icon, { name: "arrowRight" })] })) })));
}
export function LogoutLink(_a) {
    var { children, returnTo } = _a, props = __rest(_a, ["children", "returnTo"]);
    const url = new URL(CONFIG.API_ORIGIN + '/auth/logout');
    if (returnTo) {
        url.searchParams.set('returnTo', returnTo);
    }
    const [_, setWasLoggedIn] = useWasLoggedIn();
    return (_jsx("a", Object.assign({ href: url.toString(), onClick: () => setWasLoggedIn(false) }, props, { children: children !== null && children !== void 0 ? children : _jsx(_Fragment, { children: "Log out" }) })));
}
//# sourceMappingURL=LogoutButton.js.map